module.exports = __webpack_public_path__ + "static/media/Region_20_Contest_Schedule_2025_2026_8_5_25.3a1d75e9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/25-26/Region_20_Contest_Schedule_2025_2026_8_5_25.pdf
// module id = 252
// module chunks = 0